// extracted by mini-css-extract-plugin
export default {"typing-indicator":"TypingIndicator_typing-indicator__RNsvX","dot":"TypingIndicator_dot__PPXXE","blink":"TypingIndicator_blink__eRsPE"};